'use client';

import {
  type MessageHandler,
  useNativeMessageListener as useNativeMessagePackageListener
} from '@carvana/merch-native';
import { useContext, useMemo } from 'react';
import { isNonProd } from '~/constants/environment';
import ErrorContext from '~/context/common/ErrorContext';
import { generateErrorLogger } from '~/utilities/loggers';
import { useCloseModalHandler } from './handlers';
import { ListenerEvent, type ListenerEventType } from './handlers/constants';
import { useErrorHandler } from '../common/handlers';

export default function useNativeMessageListener() {
  const { setNativeError } = useContext(ErrorContext);
  const closeModalHandler = useCloseModalHandler();
  const errorHandler = useErrorHandler<ListenerEventType>();

  const handlers = useMemo<Array<MessageHandler<ListenerEventType, any>>>(
    () => [closeModalHandler, errorHandler],
    [closeModalHandler, errorHandler]
  );

  useNativeMessagePackageListener<ListenerEventType>({
    handlers,
    knownEvents: ListenerEvent,
    logErrorToTelemetry: generateErrorLogger('Finance native message listener'),
    logErrorToUser(_err) {
      setNativeError(new Error('Something went wrong. Please try again.'));
    },
    verboseLogs: isNonProd
  });
}
